import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import c from '../../../../classnames.scss'
import {getTax} from '../../../../../selectors/tax-and-fee'
import s from './tax.scss'
import {TaxProps} from '.'

export const Tax = ({t, ticket, event, className}: TaxProps) => {
  const tax = getTax(event, ticket, t)

  if (!tax) {
    return null
  }

  return (
    <div
      className={classNames(c.evTicketAdditionalInfoColor, s.tax, className)}
      data-hook={DH.TAX_LABEL}
      aria-label={t('mobile.thanks.tax', {tax})}
    >
      {tax}
    </div>
  )
}
